import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-courses-grid-style-two-columns-two-page',
  templateUrl: './courses-grid-style-two-columns-two-page.component.html',
  styleUrls: ['./courses-grid-style-two-columns-two-page.component.scss']
})
export class CoursesGridStyleTwoColumnsTwoPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
